import { Box, Tabs, Tab } from "@mui/material";

import UserIcon from "../../../../../Assets/Icons/user-icon.png";
import UserIconDark from "../../../../../Assets/Icons/user-icon-dark.png";
import LockIcon from "../../../../../Assets/Icons/lock-icon.png";
import LockIconDark from "../../../../../Assets/Icons/lock-icon-dark.png";
// import DeviceIcon from "../../../../../Assets/Icons/tablet-icon.png";
// import DeviceIconDark from "../../../../../Assets/Icons/tablet-icon-dark.png";

import EmployeeInfoForm from "./employee-info/EmployeeInfo";
import AccessSettingForm from "./AccessSetting";
// import AssignedDeviceForm from "./AssignedDevice";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const tabStyles = {
  "&.Mui-selected": { color: "#7152F3" },
};

const FormTabs = ({
  tabIndex,
  formData,
  handleTabChange,
  handleFormChange,
  handleProfilePicChange,
  formErrors,
  isSubmitting,
  mode,
  devices,
}) => {
  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="employee form tabs"
        >
          <Tab
            icon={
              <img
                src={tabIndex === 0 ? UserIcon : UserIconDark}
                alt="User icon"
                width="32"
                height="32"
              />
            }
            iconPosition="start"
            label="Employee Information"
            id="tab-0"
            aria-controls="tabpanel-0"
            sx={tabStyles}
          />
          <Tab
            icon={
              <img
                src={tabIndex === 1 ? LockIcon : LockIconDark}
                alt="Lock icon"
                width="32"
                height="32"
              />
            }
            iconPosition="start"
            label="Access Settings"
            id="tab-1"
            aria-controls="tabpanel-1"
            sx={tabStyles}
          />
          {/* <Tab
            icon={
              <img
                src={tabIndex === 2 ? DeviceIcon : DeviceIconDark}
                alt="Device icon"
                width="32"
                height="32"
              />
            }
            iconPosition="start"
            label="Assigned Device"
            id="tab-2"
            aria-controls="tabpanel-2"
            sx={tabStyles}
          /> */}
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <EmployeeInfoForm
          formData={formData}
          onDataChange={handleFormChange}
          onProfilePicChange={handleProfilePicChange}
          errors={formErrors}
          isSubmitting={isSubmitting}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <AccessSettingForm
          formData={formData}
          onDataChange={handleFormChange}
          isSubmitting={isSubmitting}
          isEditMode={mode === "edit"}
        />
      </TabPanel>
      {/* <TabPanel value={tabIndex} index={2}>
        <AssignedDeviceForm
          formData={formData}
          onDataChange={handleFormChange}
          errors={formErrors}
          isSubmitting={isSubmitting}
          devices={devices}
          mode={mode}
        />
      </TabPanel> */}
    </>
  );
};

export default FormTabs;
